import { useEffect } from "react"
import useDynamicForm from "~hooks/useRedemptionForm"
import DynamicForm from "~components/form/DynamicForm"
import { DYNAMIC_FORM_TYPES } from "~components/redemption/RedeemModal"

interface Props {
  formId: DYNAMIC_FORM_TYPES
}

const DynamicRedemption = ({ formId }: Props) => {
  const {
    data: dynamicFormData,
    isFetching: isFetchingForm,
    refetch: fetchFormData,
  } = useDynamicForm(formId)

  useEffect(() => {
    ;(async () => {
      await fetchFormData()
    })()
  }, [])

  return (
    <>
      {isFetchingForm ? (
        <>Loading...</>
      ) : (
        <DynamicForm data={dynamicFormData} />
      )}
    </>
  )
}

export default DynamicRedemption
